module.exports = __webpack_public_path__ + "img/web-call-icon.dd6e352b.svg";